import { jsx as _jsx } from "react/jsx-runtime";
const isStaging = process.env.MOJE_DEPLOY_ENV === 'staging';
const bannerStyle = {
    position: 'fixed',
    inset: 0,
    zIndex: 99999,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'clamp(1.25rem, 4vw, 2.75rem)',
    fontWeight: 700,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: 'rgba(220, 38, 38, 0.22)',
    transform: 'rotate(-24deg)',
    userSelect: 'none',
    whiteSpace: 'nowrap',
};
export const StagingEnvironmentBanner = () => {
    if (!isStaging)
        return null;
    return (_jsx("div", { "aria-hidden": true, style: bannerStyle, children: "\u6D4B\u8BD5\u73AF\u5883 \u00B7 STAGING \u00B7 NOT PRODUCTION" }));
};
